import { useState } from "react";
import api from "./appelApi";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.post("/api/auth/login", { email, password });
      localStorage.setItem("peak_token", res.data.token);
      localStorage.setItem("peak_user", JSON.stringify(res.data));
      onLogin(res.data);
    } catch (e) {
      setError("Email ou mot de passe incorrect");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight:"100vh", background:"#0a0f1a",
      display:"flex", alignItems:"center", justifyContent:"center"
    }}>
      <div style={{
        background:"#111827", border:"1px solid #1e293b",
        borderRadius:16, padding:"48px 40px", width:380,
        boxShadow:"0 25px 50px rgba(0,0,0,.5)"
      }}>
        <div style={{textAlign:"center", marginBottom:32}}>
          <div style={{fontSize:28, fontWeight:800, color:"#f1f5f9", letterSpacing:"-.02em"}}>
            Luxolor <span style={{color:"#2563eb"}}>Retail</span>
          </div>
          <div style={{fontSize:13, color:"#64748b", marginTop:4}}>Intelligence Dashboard</div>
        </div>

        <div style={{display:"flex", flexDirection:"column", gap:16}}>
          <div>
            <div style={{fontSize:12, color:"#94a3b8", marginBottom:6, fontWeight:600}}>EMAIL</div>
            <input
              type="email"
              value={email}
              onChange={e=>setEmail(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&handleSubmit()}
              placeholder="votre@email.com"
              style={{
                width:"100%", background:"#1e293b", border:"1px solid #334155",
                borderRadius:8, padding:"10px 14px", color:"#f1f5f9",
                fontSize:14, outline:"none", boxSizing:"border-box"
              }}
            />
          </div>
          <div>
            <div style={{fontSize:12, color:"#94a3b8", marginBottom:6, fontWeight:600}}>MOT DE PASSE</div>
            <input
              type="password"
              value={password}
              onChange={e=>setPassword(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&handleSubmit()}
              placeholder="••••••••"
              style={{
                width:"100%", background:"#1e293b", border:"1px solid #334155",
                borderRadius:8, padding:"10px 14px", color:"#f1f5f9",
                fontSize:14, outline:"none", boxSizing:"border-box"
              }}
            />
          </div>

          {error && (
            <div style={{color:"#ef4444", fontSize:13, textAlign:"center", background:"rgba(239,68,68,.1)", padding:"8px 12px", borderRadius:8}}>
              {error}
            </div>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: loading ? "#1e293b" : "#2563eb",
              color:"#fff", border:"none", borderRadius:8,
              padding:"12px", fontSize:14, fontWeight:700,
              cursor: loading ? "not-allowed" : "pointer",
              marginTop:8, transition:"all .15s"
            }}
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </div>

        <div style={{textAlign:"center", marginTop:24, fontSize:12, color:"#475569"}}>
          Luxolor Retail Intelligence · Tunisie
        </div>
      </div>
    </div>
  );
}
